module.exports = __webpack_public_path__ + "static/media/dgl3.png.e4956170.jpg";